import { render, staticRenderFns } from "./FirstAppointmentRequests.vue?vue&type=template&id=848cbefa&"
import script from "./FirstAppointmentRequests.vue?vue&type=script&lang=js&"
export * from "./FirstAppointmentRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports